import { render } from "./HeaderNav.vue?vue&type=template&id=4486bc0e&scoped=true"
import script from "./HeaderNav.vue?vue&type=script&lang=js"
export * from "./HeaderNav.vue?vue&type=script&lang=js"

import "./HeaderNav.vue?vue&type=style&index=0&id=4486bc0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4486bc0e"]])

export default __exports__